import React from 'react'
import { AiOutlineArrowLeft } from 'react-icons/ai'
import { useNavigate } from 'react-router-dom'

function GoBackIcon({ color }) {
  const navigate = useNavigate()
  return (
    <AiOutlineArrowLeft
      color={color}
      size={20}
      style={{ cursor: 'pointer' }}
      onClick={() => navigate(-1)}
    />
  )
}

export default GoBackIcon
